// 语言只影响展示，不修改输入值、接口参数或业务数据。
import { useSyncExternalStore } from "react";
import messages from "./en.json";

export type Locale = "zh" | "en";
const KEY = "csp-language";
const listeners = new Set<() => void>();
function readLocale(): Locale {
  try { return localStorage.getItem(KEY) === "en" ? "en" : "zh"; } catch { return "zh"; }
}
let locale = readLocale();
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};
export const getLocale = () => locale;
function updateDocument(): void {
  document.documentElement.lang = locale === "en" ? "en" : "zh-CN";
  document.title = locale === "en" ? "CSP Admin" : "CSP 任务后台";
}
export function useLocale(): Locale {
  return useSyncExternalStore(subscribe, getLocale, () => "zh");
}
export function setLocale(next: Locale): void {
  locale = next;
  try { localStorage.setItem(KEY, next); } catch { /* 存储受限时仍可切换 */ }
  updateDocument();
  for (const listener of listeners) listener();
}
if (typeof window !== "undefined") {
  updateDocument();
  window.addEventListener("storage", (event) => {
    if (event.key !== KEY && event.key !== null) return;
    locale = readLocale();
    updateDocument();
    for (const listener of listeners) listener();
  });
}

const dictionary: Record<string, string> = messages;
const escapeRegex = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const patterns = Object.entries(dictionary).filter(([key]) => /\{\d+\}/.test(key))
  .sort(([a], [b]) => b.replace(/\{\d+\}/g, "").length - a.replace(/\{\d+\}/g, "").length)
  .map(([key, value]) => {
  const indices: number[] = [];
  const parts = key.split(/(\{\d+\})/).map((part) => {
    const match = /^\{(\d+)\}$/.exec(part);
    if (!match) return escapeRegex(part);
    indices.push(Number(match[1]));
    return "(.+?)";
  });
  return { regex: new RegExp(`^${parts.join("")}$`, "s"), value, indices };
});

export function translate(source: string, lang: Locale = locale): string {
  if (lang === "zh" || !/[\u3400-\u9fff]/.test(source)) return source;
  const trimmed = source.trim();
  let result = dictionary[trimmed];
  if (result === undefined) {
    for (const pattern of patterns) {
      const match = pattern.regex.exec(trimmed);
      if (!match) continue;
      result = pattern.value.replace(/\{(\d+)\}/g, (_, index: string) => {
        const part = match[pattern.indices.indexOf(Number(index)) + 1] ?? "";
        return part.length < trimmed.length ? translate(part, lang) : part;
      });
      break;
    }
  }
  if (result === undefined) return source;
  return source.slice(0, source.indexOf(trimmed)) + result + source.slice(source.indexOf(trimmed) + trimmed.length);
}
